import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { tvImageDetails } from "src/sagas/eventSaga";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppTvImageSelector } from "src/_common/hooks/selectors/eventSelector";
import { removeEmptyObjectKey, removeTrailingZero, SOCKET_CHANNEL, SOCKET_URL } from "src/_config";
import useSocket from 'use-socket.io-client';

interface RPRodeoNewTvImageProps {
    globalTvData: any,
    socketChannel: any,
    setGlobalTvData: Function,
    setSocketChannel: Function,
}

export function RodeoNewTvImageComponent({globalTvData, socketChannel, setGlobalTvData, setSocketChannel}:RPRodeoNewTvImageProps) {

    const eventApi = useEventApi()
    const tvImageSelector = useAppTvImageSelector()
    const { gameId } = useParams<any>();
    const [isInitialLoad, setIsInitialLoad] = useState<boolean>(false)
    const [isShowingAdsPromotion, setIsShowingAdsPromotion] = useState<boolean>(false)
    const [addPromotionImage, setAddPromotionImage] = useState<any>(null)
    const [addPromotionText, setAddPromotionText] = useState<any>(null)
    const [defaultAdsPromotionTime, setDefaultAdsPromotionTime] = useState<number>(1000)


    const getTvImageDetails = (screen1: string, type: any) => {
        const params = {
            screen1, type
        }
        eventApi.callTvImageDetails(removeEmptyObjectKey(params),
            (message: string, resp: any) => {
            }, (message: string) => {
                console.error(`Error at API Access => ${message}`)
            })
    }

    const resetCssStyle = (type: any) => {
        var element = document.getElementById('rodeo_body');
        if (element) {
            if(["leaderboard","ad"].includes(type)) {
                element.style.padding = '0 30px'
                element.style.paddingTop = '2.5em'
            }
            else {
                element.style.padding = '0px'
            }
        }
    }

    // const resetCssStyle = () => {
    //     var element = document.getElementById('rodeo_body');
    //     if (element) {
    //         element.style.paddingTop = '2.5em'
    //     }
    // }

    //Socket Implementation start here
    const [socket] = useSocket(SOCKET_URL, {
        autoConnect: false,
    });

    useEffect(() => {
        // socket.connect()
        // socket.on(SOCKET_CHANNEL.TV_BOARD_IMAGE, (tvImageData: any) => {
        //     if (tvImageData.type == "rodeo_event") {
        //         getTvImageDetails(tvImageData.rodeo_event_id, "N")
        //         // resetCssStyle("leaderboard")
        //         // resetCssStyle()
        //         setIsShowingAdsPromotion(false)
        //         setIsInitialLoad(false)
        //     } else if (tvImageData.type == "rodeo_event_overall") {
        //         getTvImageDetails(tvImageData.rodeo_event_id, "OE")
        //         // resetCssStyle("leaderboard")
        //         // resetCssStyle()
        //         setIsShowingAdsPromotion(false)
        //         setIsInitialLoad(false)
        //     } else if (tvImageData.type == "event") {
        //         getTvImageDetails(`${tvImageData.rodeo_event_id}||${tvImageData.event_id}`, "N")
        //         // resetCssStyle("leaderboard")
        //         // resetCssStyle()
        //         setIsShowingAdsPromotion(false)
        //         setIsInitialLoad(false)
        //     } else {
        //         // resetCssStyle("landing")
        //         // getTvImageDetails(gameId, null)
        //         setIsInitialLoad(true)
        //     }
        // });

        // socket.on(SOCKET_CHANNEL.ADV_PROMOTION, (adsPromotionData: any) => {
        //     console.log(adsPromotionData)
        //     // resetCssStyle("ad")
        //     setIsInitialLoad(false)

        //     setIsShowingAdsPromotion(true)
        //     setAddPromotionText(adsPromotionData.text)
        //     setAddPromotionImage(adsPromotionData.image)
        //     setDefaultAdsPromotionTime(adsPromotionData.default_timeout)
        // });

        // return () => {
        //     socket.disconnect()
        // }
    }, [])

    //Reset Reducer data after component unmount
    useEffect(() => {
        return () => {
        }
    }, [])

    useEffect(()=>{

        if(globalTvData && socketChannel) {

            // console.log({globalTvData, socketChannel})
            resetCssStyle("landing")
            
            switch(socketChannel) {

                case SOCKET_CHANNEL.TV_BOARD_IMAGE:
                    if (globalTvData.type == "rodeo_event") {
                        getTvImageDetails(globalTvData.rodeo_event_id, "N")
                        // console.log("1")
                        // resetCssStyle("leaderboard")
                        // resetCssStyle()
                        setIsShowingAdsPromotion(false)
                        setIsInitialLoad(false)
                    } else if (globalTvData.type == "rodeo_event_overall") {
                        getTvImageDetails(globalTvData.rodeo_event_id, "OE")
                        // console.log("2")
                        // resetCssStyle("leaderboard")
                        // resetCssStyle()
                        setIsShowingAdsPromotion(false)
                        setIsInitialLoad(false)
                    } else if (globalTvData.type == "performance") {
                        getTvImageDetails(`${globalTvData.rodeo_event_id}||${globalTvData.performance_id}`, "N")
                        resetCssStyle("leaderboard")
                        // resetCssStyle()
                        setIsShowingAdsPromotion(false)
                        setIsInitialLoad(false)
                    } else if (globalTvData.type == "performance_overall") {
                        getTvImageDetails(`${globalTvData.rodeo_event_id}||${globalTvData.performance_id}`, "OE")
                        resetCssStyle("leaderboard")
                        // resetCssStyle()
                        setIsShowingAdsPromotion(false)
                        setIsInitialLoad(false)
                    } else if (globalTvData.type == "event") {
                        getTvImageDetails(`${globalTvData.rodeo_event_id}||${globalTvData.event_id}`, "N")
                        // console.log("3")
                        // resetCssStyle("leaderboard")
                        // resetCssStyle()
                        setIsShowingAdsPromotion(false)
                        setIsInitialLoad(false)
                    } else {
                        // resetCssStyle("landing")
                        // getTvImageDetails(gameId, null)
                        // setSocketData(globalTvData)
                        setIsInitialLoad(true)
                    }
                break;

                case SOCKET_CHANNEL.ADV_PROMOTION:
                    // console.log(globalTvData)
                    // resetCssStyle("ad")
                    setIsInitialLoad(false)

                    setIsShowingAdsPromotion(true)
                    setAddPromotionText(globalTvData.text)
                    setAddPromotionImage(globalTvData.image)
                    setDefaultAdsPromotionTime(globalTvData.default_timeout)
                break;
            }
            setGlobalTvData(null)
            setSocketChannel(null)
        }
        
    },[globalTvData, socketChannel])

    useEffect(() => {
        // getTvImageDetails(gameId, null)
        setIsInitialLoad(true)
        var element = document.getElementById('rodeo_body');
        if (element) {
            element.style.paddingTop = '0px'
            element.style.marginBottom = '0px'
            element.style.backgroundColor = '#fff'
            element.style.backgroundImage = 'none'
        }
    }, [])

    return (
        <React.Fragment>
            {
                isInitialLoad ?
                    <div className="tv-container"
                        style={{
                            backgroundImage: `url("${'/images/tv/tv-screen-blank.png'}")`,
                            position: 'fixed',
                            width: '100%',
                            height: '100%',
                            backgroundSize: 'auto 100%',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: "center center"
                        }}
                    >
                    </div>
                    :
                    <div className="tv-container">
                        <div className="left-part-tv">
                            <img src="/images/tv/left-image.png" alt="" />
                        </div>
                        <div className="right-part-tv">
                            {!isShowingAdsPromotion && <h2>{(tvImageSelector?.event_dtls?.rodeo_pick_event?.title || (tvImageSelector?.riders && tvImageSelector?.riders?.length && tvImageSelector?.riders[0]?.eventDetails)) ? "Leaderboard" : "Favorite"}</h2>}
                            <div className={"tv-player-list"}>
                                {
                                    !isShowingAdsPromotion ?
                                        <ul>
                                            {tvImageSelector?.event_dtls?.rodeo_pick_event?.title &&
                                                <li>
                                                    <div className="left-tv-list mbtm-0">
                                                        <h2>{tvImageSelector?.event_dtls?.rodeo_pick_event?.title}</h2>
                                                    </div>
                                                </li>
                                            }
                                            {
                                                tvImageSelector?.riders && tvImageSelector?.riders.length ? tvImageSelector?.riders?.slice(0, 10).map((item: any)=>
                                                    <li key={item.id} className={(!item?.eventDetails?.rodeo_pick_event?.title?"only-player":"")}>
                                                        <div className="left-tv-list">
                                                            {item?.eventDetails?.rodeo_pick_event?.title && <h2>{item?.eventDetails?.rodeo_pick_event?.title}</h2>}
                                                            <h3>{item.name}</h3>
                                                        </div>
                                                        <div className="right-tv-list">{item.vote}%</div>
                                                    </li>
                                                )
                                                :
                                                <li>
                                                    No Result Published yet
                                                </li>
                                            }
                                        </ul>
                                        :
                                        <div className="tv-ads-promotion">
                                            {addPromotionText && <h2>{addPromotionText}</h2>}
                                            <div className="ad-img">
                                                {addPromotionImage && <img className="w-100" src={addPromotionImage} alt="image" />}
                                            </div>
                                        </div>
                                    }
                            </div>
                        </div>
                    </div>
            }
        </React.Fragment>
    )
}